import React from 'react';
import axios from 'axios';

import Layout from '../../../components/Layout';
import Page from '../../../components/Page';
import Support from './Support';

import { siteUrl } from '../../../config'
import { getEditStaticPage } from '../../../lib/graphql';

async function action({ locale }) {
    const dataResult = await new Promise((resolve) => {
        require.ensure([], (require) => {
            try {
                resolve(require(`./support.${locale}.md`));
            } catch (e) {
                resolve(require('./support.md'));
            }
        }, 'support');
    });

    const response = await axios.post(`${siteUrl}/graphql`, {
        query: getEditStaticPage,
        variables: { id: 1 }
    }, {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        withCredentials: true
    })

    const { data } = await response?.data;

    if (data?.getEditStaticPage) {
        return {
            title: data?.getEditStaticPage?.result?.metaTitle,
            description: data?.getEditStaticPage?.result?.metaDescription,
            component: <Layout><Support data={data} containerClass='contentPageWrapper' /></Layout>,
        };
    } else {
        return {
            title: dataResult.title,
            component: <Layout><Page {...dataResult} containerClass='contentPageWrapper' /></Layout>,
        };
    }
}

export default action